import {removeItemAtIndex} from "./actionHelpers";

export default function addPerson(state, action) {
    let newPeople = removeItemAtIndex(state.people, action.person_index);
    return {
        ...state,
        people: newPeople
    }
}